<template>
  <div class="">
    <p @click="toLiveCalendar" style="text-align: right; color: #4b7dfd; margin-bottom: 16px; cursor: pointer">
      <!-- <a-icon type="snippets" /> -->
      <img :src="allSchedule" alt=""
        style="width: 16px; margin-right: 6px; cursor: pointer; align-items: center; justify-content: end" />
      <span style="cursor: pointer; font-size: 12px">查看全部日历</span>
    </p>
    <div class="calendar">
      <div class="arrow" @click="prev">
        <SvgIcon style="width: 16px;height: 16px;" :iconClass="'calendar-left'" />
      </div>
      <div :class="{ 'box--active': defaultDate == item.date }" class="box" v-for="item in dateList" :key="item.date"
        @click="boxClick(item)">
        <div>
          <span :style="{ color: defaultDate == item.date ? '#fff' : '#84878D', 'font-size': '12px' }">{{
            item.week
          }}</span>
        </div>
        <div>
          <span v-if="dateData.defaultDate === item.date" class="current_txt">今</span>
          <span v-else>{{ item.day }}</span>
        </div>
        <span v-if="item.studyPlanCount" :style="{
          width: '4px',
          height: '4px',
          'border-radius': '2px',
          background: defaultDate == item.date ? '#fff' : '#84878D',
        }"></span>
      </div>
      <div class="arrow" @click="next">
        <SvgIcon style="width: 16px;height: 16px;" :iconClass="'calendar-right'" />
      </div>
    </div>
    <div class="plan" v-show="isSchedule">
      <div class="plan_item" v-for="(item, index) in scheduleList" :key="item.id + '-' + index">
        <div class="plan_item_info">
          <p class="active-text">{{ item.scheduleName }}</p>
          <span v-if="item.studentShowTime">直播时间：{{ formatDate(item) }}</span>
        </div>
        <div :class="{
          no_started: item.liveStatus == 0,
          no_live: item.liveStatus == '2',
          live: item.liveStatus == '1',
          live_active: true,
        }" style="
              width: 100px;
              height: 40px;
              border-radius: 4px;
              color: #fff;
              line-height: 40px;
              text-align: center;
              cursor: pointer;
            " @click="livePlayer(item)">
          {{ item.liveStatus == 0 ? '未开始' : item.liveStatus == 1 ? '直播中' : '观看回放' }}
          <img style="width: 15px" :src="living" v-if="item.liveStatus == '1'" alt="" />
          <!-- <a-icon v-if="item.liveStatus == '1'" type="right" /> -->
        </div>
      </div>
    </div>
    <div v-show="!isSchedule" class="text-center pt-10">
      <!-- <p style="color:#5E668D;padding: 18px 0;">今日暂无直播，看看其他课程吧~</p> -->
      <img style="width: 166px" :src="emptyImg" alt="" />
      <p class="font-12 mt-2">今日暂无直播~~~</p>
      <!-- <open-course :spinning="spinning" @current-change="change" :data="courseData"></open-course> -->
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import dayjs from 'dayjs'
import SvgIcon from '@/components/SvgIcon'
// import openCourse from './openCourse'
import emptyImg from '@/assets/emptyPlan.png'
import allSchedule from '@/assets/icons/all_schedule1.png'
import { feachWeekStudyPlan, getOpenSchedulePage, getScheduleList } from '@/api/user'
import { goToLivePlayer } from '@/utils/livePlay'
import living from '@/assets/icons/living.gif'
export default {
  name: 'StudyPlan',
  props: {
    // planClassesId: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      emptyImg,
      living,
      allSchedule,
      dateData: {},
      studyPlanList: [],
      scheduleList: [],
      isSchedule: true,
      courseData: {
        records: [],
        total: 0,
      },
      defaultDate: '',
      spinning: false,
    }
  },
  watch: {
    // planClassesId(val) {
    //   const planClassesId = val === '0' ? '' : val
    //   const { startDate, endDate } = this.dateData
    //   this.feachWeekStudyPlanAsync({ startDate, endDate, planClassesId })
    // },
    dateData(val, oldVal) {
      if (!Object.keys(oldVal).length) return
      const { startDate, endDate, defaultDate } = val
      this.defaultDate = defaultDate || startDate
      this.feachWeekStudyPlanAsync({ startDate, endDate })
    },
  },
  computed: {
    dateList() {
      if (!this.studyPlanList || !this.studyPlanList.length) return this.dateData.dateList
      const arr = []
      this.dateData.dateList.forEach((item, index) => {
        const defaultWeek = item.week
        // console.log(item)
        switch (defaultWeek) {
          case 1:
            item.week = 'M'
            break
          case 2:
            item.week = 'T'
            break
          case 3:
            item.week = 'W'
            break
          case 4:
            item.week = 'T'
            break
          case 5:
            item.week = 'F'
            break
          case 6:
            item.week = 'S'
            break
          case 7:
            item.week = 'S'
            break
          default:
            break
        }
        arr[index] = { ...item }
        this.studyPlanList.forEach((it) => {
          if (it.date === item.date) {
            arr[index] = Object.assign(arr[index], it)
          }
        })
      })
      return arr
    },
  },
  components: {
    SvgIcon
    // openCourse
  },
  created() {
    const res = this.weekDate()
    // console.log(res)
    const { startDate, endDate, defaultDate } = res
    this.dateData = res
    this.defaultDate = defaultDate || startDate
    this.feachWeekStudyPlanAsync({ startDate, endDate })
  },
  methods: {
    livePlayer(data) {
      const { liveStatus, id, planclassesId = '' } = data
      switch (liveStatus) {
        case '0':
          this.$message.warning('直播尚未开始')
          break
        case '1':
        case '2':
          goToLivePlayer(id, planclassesId)
          break
      }
    },
    formatDate({ liveTimeStar, liveTimeEnd }) {
      const start = liveTimeStar.split(' ')[1]
      const end = liveTimeEnd.split(' ')[1]
      return start + '~' + end
    },
    boxClick(ev) {
      this.defaultDate = ev.date
      this.getScheduleListAsync(ev)
    },
    // change(ev) {
    //   this.getOpenSchedulePageAsync(ev)
    // },
    // 获取周学习计划
    async feachWeekStudyPlanAsync({ startDate, endDate, planClassesId }) {
      try {
        const res = await feachWeekStudyPlan({
          startTime: startDate,
          endTime: endDate,
          // planClassesId
        })
        this.studyPlanList = res
        // console.log('res', res)
        if (res) {
          const data = res.find((item) => item.date === this.defaultDate)
          this.getScheduleListAsync(data)
        } else {
          this.scheduleList = []
          this.isSchedule = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取课次信息
    async getScheduleListAsync(data) {
      if (!data) {
        this.scheduleList = []
        this.isSchedule = false
        return
      }
      const { date } = data
      // if (!scheduleList?.length) {
      //   this.scheduleList = []
      //   this.isSchedule = false
      //   return
      // }
      // console.log('scheduleList', scheduleList)
      // return
      // const { isRepeatArr } = await this.formatScheduleIds(scheduleList)
      try {
        this.isSchedule = true
        // this.scheduleList = []
        const res = await getScheduleList({
          date,
          // scheduleIds
        })
        // this.formatCcheduleList(res, isRepeatArr)
        // this.scheduleList = res
        this.scheduleList = res
        !res?.length && (this.isSchedule = false)
        // this.scheduleList = this.formatCcheduleList(res, isRepeatArr)
      } catch (error) {
        console.log(error)
      }
    },
    // formatCcheduleList(list1, list2) {
    //   const arr = []
    //   // console.log('list1', list1)
    //   // console.log('list2', list2)
    //   // const a = new A()
    //   // console.log('a', a)
    //   list2.map(item => {
    //     const data = list1.filter(it => it.id === item.scheduleId)
    //     item.planclassesId.forEach((item) => {
    //       arr.push({
    //         planclassesId: item,
    //         ...data[0],
    //       })
    //     })
    //   })
    //   // console.log('arr', arr)
    //   return arr
    //   // const arr = list1.filter(item => {
    //   //   if (list2.includes(item.id)) {
    //   //     return item
    //   //   }
    //   // })
    //   // return [...list1, ...arr]
    // },
    // formatScheduleIds(list) {
    //   const isRepeatArr = []
    //   const arr = list.map(item => {
    //     // if (item.planclassesId && item.planclassesId.length > 1) {
    //     //   // console.log('item.planclassesId', item.planclassesId.length)
    //     //   // item.planClassesId.map(() => isRepeatArr.push(item.scheduleId))
    //     //   isRepeatArr.push({
    //     //     len: item.planclassesId.length - 1,
    //     //     scheduleId: item.scheduleId
    //     //   })
    //     // }
    //     isRepeatArr.push({
    //       planclassesId: item.planclassesId || [null],
    //       scheduleId: item.scheduleId
    //     })
    //     return item.scheduleId
    //   })
    //   return Promise.resolve({
    //     isRepeatArr,
    //     scheduleIds: arr.join(',')
    //   })
    // },
    // 获取公开课
    async getOpenSchedulePageAsync(current = 1) {
      try {
        this.isSchedule = false
        this.spinning = true
        const { records, total } = await getOpenSchedulePage({
          current,
          size: 8,
        })
        this.courseData.records = records
        this.courseData.total = total
      } catch (error) {
        console.log(error)
      } finally {
        this.spinning = false
      }
    },
    prev() {
      const res = this.weekDate(this.dateData.dateList[0].date)
      this.dateData = res
    },
    next() {
      const res = this.weekDate(this.dateData.dateList[6].date)
      this.dateData = res
    },
    weekDate(date) {
      let obj = {}
      // 获取当前周几
      const day = dayjs(date).day()
      // 根据周一得到一周七天时间
      const sevenDate = (start) => {
        const list = []
        const activeDate = dayjs().format('YYYY-MM-DD')
        let defaultDate = ''
        for (let i = 0; i < 7; i++) {
          const date = dayjs(start).add(i, 'day').format('YYYY-MM-DD')
          if (activeDate === date) {
            defaultDate = date
          }
          let weekName = dayjs(start).add(i, 'day').day() ? dayjs(start).add(i, 'day').day() : 7
          switch (weekName) {
            case 1:
              weekName = 'M'
              break
            case 2:
              weekName = 'T'
              break
            case 3:
              weekName = 'W'
              break
            case 4:
              weekName = 'T'
              break
            case 5:
              weekName = 'F'
              break
            case 6:
              weekName = 'S'
              break
            case 7:
              weekName = 'S'
              break
            default:
              break
          }
          list.push({
            date,
            week: weekName,
            day: dayjs(start).add(i, 'day').date(),
          })
        }
        return {
          dateList: list,
          defaultDate,
        }
      }
      const fun1 = (num) => {
        let startDate = ''
        let endDate = ''
        if (num === 0) {
          startDate = dayjs(date).add(1, 'day').format('YYYY-MM-DD')
          endDate = dayjs(date).add(7, 'day').format('YYYY-MM-DD')
        } else if (num === 1) {
          startDate = dayjs(date).subtract(7, 'day').format('YYYY-MM-DD')
          endDate = dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')
        } else {
          startDate = dayjs(date)
            .subtract(num - 1, 'day')
            .format('YYYY-MM-DD')
          endDate = dayjs(date)
            .add(7 - num, 'day')
            .format('YYYY-MM-DD')
        }
        return {
          startDate,
          endDate,
        }
      }
      const fun2 = (num) => {
        if (num === 0) {
          num = 7
        }
        const startDate = dayjs()
          .subtract(num - 1, 'day')
          .format('YYYY-MM-DD') // 周一的日期
        const endDate = dayjs(startDate).add(6, 'day').format('YYYY-MM-DD')
        const defaultDate = dayjs().format('YYYY-MM-DD')
        let defaultWeek = dayjs().day()
        switch (defaultWeek) {
          case 1:
            defaultWeek = 'M'
            break
          case 2:
            defaultWeek = 'T'
            break
          case 3:
            defaultWeek = 'W'
            break
          case 4:
            defaultWeek = 'T'
            break
          case 5:
            defaultWeek = 'F'
            break
          case 6:
            defaultWeek = 'S'
            break
          case 7:
            defaultWeek = 'S'
            break
          default:
            break
        }
        return { startDate, endDate, defaultDate, defaultWeek }
      }
      // 已知时间
      if (date) {
        obj = fun1(day)
      } else {
        // 默认时间
        obj = fun2(day)
      }
      const dateList = sevenDate(obj.startDate)
      return { ...obj, ...dateList }
    },
    toLiveCalendar() {
      this.$router.push({ name: 'liveCalendar', query: { ocode: Vue.ls.get('code') } })
    },
  },
}
</script>
<style lang="less" scoped>
.calendar {
  display: flex;
  justify-content: space-between;
  height: 60px;

  .box {
    width: 90px;
    height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f5f6fa;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;

    .current_txt {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 50%;
      // border: 1px solid #1564ff;
      color: #303133;
    }

    .p {
      margin-bottom: 5px;
      color: #5e668d;
    }

    span {
      color: #181d21;
    }
  }

  .box--active {
    color: #fff;
    background: #4b7dfd;

    .current_txt {
      // border: 1px solid #fff;
      color: #fff;
    }

    span {
      color: #fff;
    }
  }

  .arrow {
    width: 35px;
    background: #f5f6fa;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .anticon {
      line-height: 72px;
      font-size: 16px;
      color: #aeb5c5;
    }
  }
}

.plan {

  // padding: 12px;
  .plan_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 94px;
    margin: 16px 0;
    padding: 16px;
    background: #ffffff;
    border-radius: 5px;

    &:hover {
      box-shadow: 2px 2px 16px 0px rgba(0, 0, 0, 0.07);

      .active-text {
        color: #4b7dfd;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // background: #F7F9FF;
      }
    }

    .plan_item_info {
      flex: 1;
      width: calc(100% - 105px);

      p {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: bold;
        color: #303133;
      }
    }

    span {
      color: #84878d;
      font-size: 12px;
    }

    .ant-btn {
      width: 75px;
      height: 28px;
      padding-left: 0;
      padding-right: 0;
      margin-left: 12px;
      // line-height: 28px;
      border-radius: 14px;
      align-self: end;

      img {
        width: 12px;
        height: 12px;
        margin-left: 2px;
      }
    }

    .ant-btn-primary {
      color: #fff;
      // background-color: #1564ff;
    }
  }
}

.courses {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 8px;

  .course_item {
    display: flex;
    flex: 45%;
    height: 163px;
    margin: 0 12px;
    margin-bottom: 12px;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);

    .item_info {
      padding: 12px;
      display: flex;
      flex-direction: column;
      color: #5e668d;

      .title {
        font-size: 14px;
        color: #181d21;
      }

      .tag {
        width: max-content;
        padding: 3px;
        margin: 8px 0;
        color: #fff;
        background: #00cbde;
        border-radius: 3px;
      }

      .apply {
        align-self: end;
        margin-top: 16px;
      }

      span {
        font-size: 12px;
        line-height: 12px;
      }
    }

    img {
      width: 195px;
      height: 147px;
      object-fit: contain;
      align-self: center;
    }
  }
}

.ant-pagination {
  text-align: center;
}

.no_live {
  background: #396cef;
}

.no_started {
  background: #d6d7d8;
  border: 1px solid #f5f6fa;
  color: #fff;
}

.live {
  background: #fc665c;
}

.live_active:hover {
  background: #4B7DFD;
}

// .live_active:hover {
//   background: #40a9ff;
// }
</style>
